import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import TestManagement from '../pages/TestManagement';
import CandidateUpload from '../modules/test-management/candidate-upload/components/Index';
import TestUpload from '../modules/test-management/test-upload/components';
import ForgotPassword from '../pages/ForgotPassword';
import AdminLogin from '../pages/AdminLogin';
import ViewReport from '../pages/ViewReport';
import ReportScreen from '../pages/ReportScreen';
import TestResult from '../modules/report/TestResult';
import ProctoringData from '../modules/report/ProctoringData';
import AccountSettings from '../pages/AccountSettings';
import Report from '../modules/test-management/report';

const routes: RouteObject[] = [
  {
    path: '/*',
    element: <AdminLogin />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/report',
    element: <ViewReport />,
  },
  {
    path: 'report/:candidateId',
    element: <ReportScreen />,
    children: [
      { path: '', element: <TestResult /> },
      { path: 'proctoring', element: <ProctoringData /> },
    ],
  },
  {
    path: '/account-settings',
    element: <AccountSettings />,
  },
  {
    path: '/login',
    element: <AdminLogin />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/test-management',
    element: <TestManagement />,
    children: [
      {
        path: '',
        element: <CandidateUpload />,
      },
      {
        path: 'candidate-upload',
        element: <CandidateUpload />,
      },
      {
        path: 'test-upload',
        element: <TestUpload />,
      },
      {
        path: 'report',
        element: <Report />,
      },
    ],
  },
];

const router = createBrowserRouter(routes);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
